import { shouldUseAmplify } from './apiTarget';

/**
 * Regions where clinic equipment is not available.
 */
export const CLINIC_EQUIPMENT_UNSUPPORTED_REGIONS = [
  'LATAM',
  'CLASA',
];

/**
 * Determine whether the clinic equipment experience should be available.
 *
 * @param {Object} [provider={}] - Current provider details
 * @returns {boolean}
 */
export function shouldUseNewClinicEquipment(provider = {}) {
  return (
    shouldUseAmplify(provider?.useNewSRPortal ?? false) &&
    !CLINIC_EQUIPMENT_UNSUPPORTED_REGIONS.includes(provider?.region)
  );
}
